<template>
  <DxPopup
    :visible="popupVisible"
    :drag-enabled="true"
    :close-on-outside-click="false"
    :show-title="true"
    :width="'70%'"
    :height="730"
    :title="'Link an Item'"
    :showCloseButton="false"
    :wrapperAttr="{ class: 'css-v2 gc-popup' }"
  >
    <div class="css-v2 transaction-list">
      <DxDataGrid
        :columns="getDataGridColumns"
        :data-source="dataSource"
        :height="630"
        :onRowDblClick="onRowDblClick"
      />
    </div>

    <div class="footer link-an-item-popup-footer">
      <DxButton
        text="Cancel"
        type="default"
        styling-mode="contained"
        class="cancel-btn"
        @click="popupHidden"
      />
    </div>
  </DxPopup>
</template>

<script>
import BaseViewMixin from "../v1/_mixins/base.view";
import ApiService from "../_services/api/api.service";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    linkAnItemData: Object,
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      productDataSource: undefined,
      productColumns: [],
      dataSource: [],
    };
  },
  async created() {
    await ApiService.get("api/ProductPurchaseList")
      .then((res) => {
        // Get the product codes associated with the current supplier
        let supplierItemsArray = res.data.value
          .filter((row) => row.SupplierCode == this.linkAnItemData.SupplierCode)
          .map((element) => element.ProductCode);
        // convert the array to a dictionary for faster indexing
        let supplierItemSet = new Set(supplierItemsArray);
        // Get the product codes that are not associated with the current supplier
        // The data contains the data for all suppliers, therefore there could be multiple entries for the same product
        // therefore, only select the product codes that are not associated with the supplier.
        this.dataSource = res.data.value.filter(
          (row) => !supplierItemSet.has(row.ProductCode)
        );
      })
      .catch((error) => {
        this.$logger.debug("error getting products", error);
      });
  },
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
    getDataGridColumns() {
      return [
        {
          caption: "Product Code",
          dataField: "ProductCode",
        },
        {
          caption: "Product Description",
          dataField: "ProductDescription1",
        },
      ];
    },
  },
  methods: {
    popupHidden() {
      this.callBack();
    },
    onRowDblClick(row) {
      this.callBack(row.data);
    },
  },
};
</script>